import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import InputPesquisa from '../common/form/inputPesquisa';
import Aguardando from '../common/template/aguardando';
import FormatUtils from '../common/formatUtils/FormatUtils';
import { sortData } from '../common/table/sortHelper';

import { getEstoque } from './brindeActions';

const colunas = [
    { field: 'nome_brinde', type: 'text' },
    { field: 'quantidade_entrada', type: 'number' },
    { field: 'quantidade_saida', type: 'number' },
    { field: 'quantidade_estoque', type: 'number' },
    { field: 'valor_total_entradas', type: 'number' }
];

const BrindeEstoque = props => {
    const [pesquisa, setPesquisa] = useState('');
    const [sort, setSort] = useState({
        field: 'nome_brinde',
        direction: 'asc'
    });

    useEffect(() => {
        props.getEstoque();
    }, []);

    const onSort = field => setSort(anterior => ({
        field,
        direction:
            anterior.field === field && anterior.direction === 'asc'
                ? 'desc'
                : 'asc'
    }));

    const termo = pesquisa.trim().toUpperCase();
    const filtrado = (props.estoque || []).filter(item =>
        !termo || item.nome_brinde.toUpperCase().includes(termo)
    );
    const estoque = sortData(filtrado, sort, colunas);

    return (
        <Content>
            <Aguardando aguardando={props.aguardando} />
            <ContentCard>
                <ContentCardHeader>
                    <Row>
                        <InputPesquisa
                            cols='12 6 3 1'
                            label='Pesquisar'
                            minWidth={344}
                            onChange={setPesquisa}
                        />
                        <div style={{ marginTop: 8 }}>
                            <button
                                type='button'
                                className='btn btn-app bg-primary'
                                onClick={props.getEstoque}
                            >
                                <i className='fas fa-sync-alt' />
                                Atualizar
                            </button>
                        </div>
                    </Row>
                </ContentCardHeader>
                <ContentCardBody>
                    <Table responsive border alturaFixa striped>
                        <THead>
                            <Tr>
                                <ThSort
                                    field='nome_brinde'
                                    label='Brinde'
                                    width={280}
                                    sort={sort}
                                    onSort={onSort}
                                />
                                <ThSort
                                    field='quantidade_entrada'
                                    label='Entradas'
                                    width={130}
                                    sort={sort}
                                    onSort={onSort}
                                />
                                <ThSort
                                    field='quantidade_saida'
                                    label='Saídas'
                                    width={130}
                                    sort={sort}
                                    onSort={onSort}
                                />
                                <ThSort
                                    field='quantidade_estoque'
                                    label='Estoque atual'
                                    width={150}
                                    sort={sort}
                                    onSort={onSort}
                                />
                                <ThSort
                                    field='valor_total_entradas'
                                    label='Valor das entradas'
                                    width={170}
                                    sort={sort}
                                    onSort={onSort}
                                />
                            </Tr>
                        </THead>
                        <TBody>
                            {estoque.map(item => (
                                <Tr key={item.id_produto}>
                                    <Td alignCenter>
                                        {item.nome_brinde}
                                    </Td>
                                    <Td alignCenter>
                                        {FormatUtils.formatarValorTela(
                                            item.quantidade_entrada,
                                            0
                                        )}{' '}
                                        {item.sigla_unidade_medida}
                                    </Td>
                                    <Td alignCenter>
                                        {FormatUtils.formatarValorTela(
                                            item.quantidade_saida,
                                            0
                                        )}{' '}
                                        {item.sigla_unidade_medida}
                                    </Td>
                                    <Td
                                        alignCenter
                                        bold
                                        color={
                                            Number(item.quantidade_estoque) > 0
                                                ? '#166534'
                                                : '#991b1b'
                                        }
                                    >
                                        {FormatUtils.formatarValorTela(
                                            item.quantidade_estoque,
                                            0
                                        )}{' '}
                                        {item.sigla_unidade_medida}
                                    </Td>
                                    <Td alignCenter>
                                        R$ {' '}
                                        {FormatUtils.formatarValorTela(
                                            item.valor_total_entradas,
                                            2
                                        )}
                                    </Td>
                                </Tr>
                            ))}
                        </TBody>
                    </Table>
                </ContentCardBody>
            </ContentCard>
        </Content>
    );
};

const mapStateToProps = state => ({
    aguardando: state.brinde.aguardando,
    estoque: state.brinde.estoque
});

const mapDispatchToProps = dispatch => bindActionCreators({
    getEstoque
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BrindeEstoque);
